
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AEROPPD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AEROPPD.vue